import React from "react";
import "./index.scss";

import Header from "../../components/Header";
import Footer from "../../components/Footer";

class SobreNos extends React.Component<{}> {
  render() {
    return (
      <>
        <Header />
        <div className="container-textos">
          <h1 style={{ textAlign: "left", width: "100%" }}>
            Bem-vindo ao Açougue Domakoski!
          </h1>
          <p>&nbsp;</p>
          <p style={{ textAlign: "justify", width: "100%" }}>
            Desde 1950, com pioneirismo do Sr. Félix Domakoski, nossa missão é
            simples: oferecer carnes de altíssima qualidade, com atendimento
            dedicado e personalizado, que atenda às expectativas mais exigentes
            e pedidos específicos de cada cliente.
          </p>
          <p style={{ textAlign: "justify", width: "100%" }}>
            Somos a terceira geração da família Domakoski no ofício de
            açougueiro, e, ao longo dessas décadas de tradição, aprendemos que
            cada corte de carne merece ser tratado com o máximo de cuidado e
            respeito.
          </p>
          <p style={{ textAlign: "justify", width: "100%" }}>
            Aqui, não oferecemos apenas produtos de excelência: entregamos a
            experiência de um serviço completo e atento a cada detalhe! A cada
            dia, trabalhamos com carnes frescas certificadas, de proveniência
            controlada, selecionadas para garantir o melhor sabor e qualidade em
            cada corte.
          </p>
          <p style={{ textAlign: "justify", width: "100%" }}>
            Nossa linha de produtos inclui ampla variedade de opções, como
            carnes de bovinos, suínos, ovinos e caprinos, além de embutidos,
            pescados, aves e carnes exóticas. Tudo para que você tenha sempre o
            que há de melhor à sua mesa.
          </p>
          <p style={{ textAlign: "justify", width: "100%" }}>
            Seja para o seu churrasco de fim de semana, um almoço especial ou
            aquele jantar mais sofisticado, nossa missão é ajudar a tornar sua
            refeição inesquecível. E para garantir isso, oferecemos cortes
            especiais como o Angus Prime, Kobe Beef, carnes Dry Aged, além de
            cortes temperados, preparados e recheados, pensados para aqueles
            momentos em que a qualidade e a praticidade são essenciais.
          </p>
          <p style={{ textAlign: "justify", width: "100%" }}>
            Pensando sempre em facilitar seus momentos, também contamos com uma
            seleção de temperos, bebidas, acessórios diversos para churrasco e,
            inclusive, adega com rótulos especiais de vinhos, tudo para que você
            tenha a comodidade de encontrar tudo o que precisa em um único
            lugar.
          </p>
          <p style={{ textAlign: "justify", width: "100%" }}>
            Nosso compromisso vai além da qualidade da carne: queremos
            proporcionar um atendimento que traduza nossa história, nosso
            respeito pela tradicional arte de cortar e preparar carnes, e,
            claro, a confiança que nossos clientes depositam em nós há mais de
            70 anos.
          </p>
          <p style={{ textAlign: "justify", width: "100%" }}>
            Aqui no Domakoski é assim: mais que vender produtos, estabelecemos
            uma relação afetuosa com nossos clientes.
          </p>
          <p style={{ textAlign: "justify", width: "100%" }}>
            E é com esse compromisso de excelência, honrando nossa tradição, que
            nossa família segue oferecendo o melhor para você!
          </p>
          <p style={{ textAlign: "right", fontWeight: "bold", width: "100%" }}>
            Açougue Domakoski. <br />
            Desde 1950 agradecendo a preferência!
          </p>
        </div>
        <Footer />
      </>
    );
  }
}

export default SobreNos;
